/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Pick_Preset_RequiredInputs */



/**
* | output |
* | --- |
* | "Please select a preset." |
*
* @param {Explorer_Info_Batch_Pick_Preset_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_pick_preset_required = /** @type {((inputs?: Explorer_Info_Batch_Pick_Preset_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Pick_Preset_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez sélectionner un préréglage.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie eine Voreinstellung.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un preset.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите предустановленный вариант.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un ajuste preestablecido.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请选择一个预设。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットを選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया एक प्रीसेट चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, selecione uma predefinição.")
	return /** @type {LocalizedString} */ ("Please select a preset.")
});